'use strict';
(function () {
  var FLAG_NAME = 'hc_geo';
  var FLAG_TAIL = '; max-age=31536000; path=/; SameSite=Lax; Secure';
  var FLAG_TAIL_SHORT = '; max-age=86400; path=/; SameSite=Lax; Secure';
  var FLAG_PATTERN = /(?:^|;\s*)hc_geo=([^;]*)/;
  var CODE_PATTERN = /^[A-Z]{2}$/;
  var HOME_KEY = 'hc_home';
  var HOME_MAX = 2000;
  var UNSAFE_PATTERN = /<(?!\/?span\b|img\b)|javascript:|srcdoc|\bon[a-z]+\s*=/i;
  var BOT_PATTERN = /bot|crawl|spider|slurp|bingpreview|facebookexternalhit|lighthouse|headless/i;
  var ENDPOINT = '/browsing_context_suggestions.json?source=geolocation&country%5Benabled%5D=true';
  var ROOT = '.hc-country-selector';
  var TOGGLE = '.hc-country-selector__toggle';
  var LIST = '.hc-country-selector__list';
  var ITEM = '.hc-country-selector__item';
  var ITEM_CLASS = 'hc-country-selector__item';
  var CURRENT_ITEM = '.hc-country-selector__item[aria-selected="true"]';
  var INPUT = 'input[name="country_code"]';

  function isCode(value) {
    return typeof value === 'string' && CODE_PATTERN.test(value);
  }

  function currentCountry() {
    var body = document.body;
    if (!body || !body.dataset) {
      return '';
    }
    return (body.dataset.hcCountry || '').toUpperCase();
  }

  function servedCountries() {
    var body = document.body;
    if (!body || !body.dataset) {
      return [];
    }
    return (body.dataset.hcCountries || '').toUpperCase().split(',');
  }

  function setFlag(code, short) {
    try {
      var value = isCode(code) ? code : '1';
      document.cookie = FLAG_NAME + '=' + value + (short ? FLAG_TAIL_SHORT : FLAG_TAIL);
    } catch (error) {}
  }

  function setReturnTo(form) {
    try {
      var field = form.querySelector('input[name="return_to"]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'return_to';
        form.appendChild(field);
      }
      field.value = window.location.pathname + window.location.search;
    } catch (error) {}
  }

  function hasFlag() {
    try {
      return FLAG_PATTERN.test(document.cookie || '');
    } catch (error) {
      return true;
    }
  }

  function readFlag() {
    try {
      var match = FLAG_PATTERN.exec(document.cookie || '');
      var value = match ? match[1].toUpperCase() : '';
      return isCode(value) ? value : '';
    } catch (error) {
      return '';
    }
  }

  function toggleOf(list) {
    var form = list.closest('form');
    return form ? form.querySelector(TOGGLE) : null;
  }

  function sectionOf(list) {
    return list.closest('.shopify-section');
  }

  function closeList(list) {
    list.setAttribute('hidden', '');
    var closedSection = sectionOf(list);
    if (closedSection) {
      closedSection.classList.remove('hc-country-open');
    }
    var toggle = toggleOf(list);
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function openList(list) {
    list.removeAttribute('hidden');
    var openedSection = sectionOf(list);
    if (openedSection) {
      openedSection.classList.add('hc-country-open');
    }
    var toggle = toggleOf(list);
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
    }
  }

  function closeAll(except) {
    var lists = document.querySelectorAll(LIST);
    for (var i = 0; i < lists.length; i += 1) {
      if (lists[i] !== except && !lists[i].hasAttribute('hidden')) {
        closeList(lists[i]);
      }
    }
  }

  function onToggleClick(toggle) {
    var form = toggle.closest('form');
    var list = form ? form.querySelector(LIST) : null;
    if (!list) {
      return;
    }
    var wasHidden = list.hasAttribute('hidden');
    closeAll(list);
    if (wasHidden) {
      openList(list);
    } else {
      closeList(list);
    }
  }

  function onItemClick(item) {
    var form = item.closest('form');
    var input = form ? form.querySelector(INPUT) : null;
    var code = item.getAttribute('data-hc-country') || '';
    if (!form || !input || !code) {
      return;
    }
    if (!readFlag()) {
      setFlag(currentCountry());
    }
    input.value = code;
    setReturnTo(form);
    form.submit();
  }

  function onDocumentClick(event) {
    try {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') {
        return;
      }
      var toggle = target.closest(TOGGLE);
      if (toggle) {
        event.preventDefault();
        onToggleClick(toggle);
        return;
      }
      var item = target.closest(ITEM);
      if (item) {
        event.preventDefault();
        onItemClick(item);
        return;
      }
      if (!target.closest(ROOT)) {
        closeAll(null);
      }
    } catch (error) {}
  }

  function onDocumentKeydown(event) {
    try {
      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        closeAll(null);
      }
    } catch (error) {}
  }

  function cacheHome() {
    try {
      var current = currentCountry();
      if (!isCode(current) || readFlag() !== current) {
        return;
      }
      var list = document.querySelector(LIST);
      var item = list ? list.querySelector(CURRENT_ITEM) : null;
      if (!item || (item.getAttribute('data-hc-country') || '').toUpperCase() !== current) {
        return;
      }
      var html = item.innerHTML || '';
      if (!html || html.length > HOME_MAX || UNSAFE_PATTERN.test(html)) {
        return;
      }
      window.localStorage.setItem(HOME_KEY, JSON.stringify({ code: current, html: html }));
    } catch (error) {}
  }

  function readHome() {
    try {
      var raw = window.localStorage.getItem(HOME_KEY);
      if (!raw) {
        return null;
      }
      var home = JSON.parse(raw);
      if (!home || !isCode(home.code) || typeof home.html !== 'string') {
        return null;
      }
      if (!home.html || home.html.length > HOME_MAX || UNSAFE_PATTERN.test(home.html)) {
        return null;
      }
      return home;
    } catch (error) {
      return null;
    }
  }

  function buildHomeItem(home) {
    var li = document.createElement('li');
    li.setAttribute('role', 'none');
    var button = document.createElement('button');
    button.setAttribute('type', 'button');
    button.setAttribute('role', 'option');
    button.className = ITEM_CLASS;
    button.setAttribute('data-hc-country', home.code);
    button.setAttribute('aria-selected', 'false');
    button.innerHTML = home.html;
    li.appendChild(button);
    return li;
  }

  function injectHome() {
    try {
      var home = readHome();
      if (!home) {
        return;
      }
      var current = currentCountry();
      if (home.code === current || servedCountries().indexOf(home.code) === -1) {
        return;
      }
      var lists = document.querySelectorAll(LIST);
      for (var i = 0; i < lists.length; i += 1) {
        var list = lists[i];
        if (list.querySelector('[data-hc-country="' + home.code + '"]')) {
          continue;
        }
        var first = list.querySelector('li');
        var li = buildHomeItem(home);
        if (first) {
          list.insertBefore(li, first.nextSibling);
        } else {
          list.appendChild(li);
        }
      }
    } catch (error) {}
  }

  function readDetected(data) {
    if (!data || !data.detected_values || !data.detected_values.country) {
      return '';
    }
    var handle = data.detected_values.country.handle;
    return handle ? String(handle).toUpperCase() : '';
  }

  function switchCountry(detected, current, served) {
    if (!detected || detected === current || served.indexOf(detected) === -1) {
      return;
    }
    var form = document.getElementById('HcGeoForm');
    if (!form) {
      return;
    }
    var field = form.querySelector(INPUT);
    if (!field) {
      return;
    }
    field.value = detected;
    setReturnTo(form);
    form.submit();
  }

  function autoSwitch() {
    try {
      if (window.Shopify && window.Shopify.designMode) {
        return;
      }
      if (/^(127\.0\.0\.1|localhost)$/.test(window.location.hostname)) {
        return;
      }
      if (hasFlag()) {
        return;
      }
      if (BOT_PATTERN.test(navigator.userAgent || '')) {
        return;
      }
      var current = currentCountry();
      if (!current) {
        return;
      }
      var served = servedCountries();
      if (typeof window.fetch !== 'function') {
        return;
      }
      window.fetch(ENDPOINT, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response || !response.ok) {
          return null;
        }
        return response.json().catch(function () {
          return null;
        });
      }).then(function (data) {
        try {
          var detected = readDetected(data);
          setFlag(detected || current, !detected);
          if (!hasFlag()) {
            return;
          }
          switchCountry(detected, current, served);
        } catch (error) {}
      }).catch(function () {});
    } catch (error) {}
  }

  function init() {
    try {
      document.addEventListener('click', onDocumentClick);
      document.addEventListener('keydown', onDocumentKeydown);
    } catch (error) {}
    cacheHome();
    injectHome();
    autoSwitch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
